import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Legend, Wrapper } from './CheckGroup.styles';
export const CheckGroup = /*#__PURE__*/ forwardRef(({ children, className, collapsibleValue, 'data-testid': dataTestId, label }, ref)=>/*#__PURE__*/ _jsxs(Wrapper, {
        className: className,
        collapsible: true,
        "data-testid": dataTestId,
        ref: ref,
        type: "single",
        value: collapsibleValue,
        children: [
            !!label && /*#__PURE__*/ _jsx(Legend, {
                as: "legend",
                children: label
            }),
            children
        ]
    }));
CheckGroup.displayName = 'CheckGroup';

//# sourceMappingURL=CheckGroup.js.map